import React, { useEffect, useState } from "react";
import ContactInfo from "./ContactInfo/ContactInfo";
import MediaLinks from "./MediaLinks/MediaLinks";
import ScheduleMessage from "./ScheduleMessage/ScheduleMessage";
import AddGroupMember from "./AddGroupMember/AddGroupMember";
import {
  deleteApiCaller,
  getApiCaller,
  postApiCaller,
  putApiCaller,
  putFormDataApiCaller,
} from "../../../Libs/apiCaller";
import { toast } from "react-toastify";

export default function GroupProfileView({
  activeSection,
  setActiveSection,
  setShowProfileView,
  showAddGroupMember,
  setShowAddGroupMember,
  chatConversationId,
  secretKey,
  groupActiveChat,
  setGroupActiveChat,
  settings,
  setSettings,
  allGroups,
  setAllGroups,
  setAllMessages,
}) {
  const [mediaList, setMediaList] = useState([]);
  const [linkList, setLinkList] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [isMediaLoading, setIsMediaLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("MEDIA");
  const [mediaCurrentPage, setMediaCurrentPage] = useState(1);
  const [mediaTotalPage, setMediaTotalPage] = useState(1);
  const [linkCurrentPage, setLinkCurrentPage] = useState(1);
  const [linkTotalPage, setLinkTotalPage] = useState(1);
  const [documentsCurrentPage, setDocumentsCurrentPage] = useState(1);
  const [documentsTotalPage, setDocumentsTotalPage] = useState(1);
  const [totalMedia, setTotalMedia] = useState(0);
  const [allUser, setAllUser] = useState([]);
  const [allUserCurrentPage, setAllUserCurrentPage] = useState(1);
  const [allUserTotalPages, setAllUserTotalPages] = useState(1);
  const [allUserTotalRecords, setAllUserTotalRecords] = useState(0);
  const [selectedUser, setSelectedUser] = useState(null);
  const [removeUserModal, setRemoveUserModal] = useState(false);

  useEffect(() => {
    fetchAllUser(1, "");
  }, [showAddGroupMember]);

  const fetchAllUser = async (page = allUserCurrentPage, search) => {
    const endpoint = `users/all_user_app?page=${page}&limit=20&search=${search}`;
    const response = await getApiCaller(endpoint);
    if (response?.status === 200) {
      const remainingUsers = response.data.users.filter(
        (user) => !groupActiveChat.users.some((u) => u._id === user._id)
      );
      setAllUser((prev) =>
        page == 1 ? remainingUsers : [...prev, ...remainingUsers]
      );
      setAllUserCurrentPage(response.data.pagination.currentPage);
      setAllUserTotalPages(response.data.pagination.totalPages);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  useEffect(() => {
    if (chatConversationId._id) {
      getMediaList();
    }
  }, [chatConversationId]);

  const getMediaList = async (type = "MEDIA", page = 1) => {
    page == 1 && setIsMediaLoading(true);
    const endPoint = `messages/media/get`;
    const response = await postApiCaller(endPoint, {
      conversationId: chatConversationId._id,
      mediaType: type,
      page,
    });

    if (response.status == 200) {
      setAllUserTotalRecords(response?.data?.allTotalRecords || 0);
      if (type === "MEDIA") {
        setMediaList((prev) =>
          page == 1 ? response.data.data : [...prev, ...response.data.data]
        );
        setMediaCurrentPage(response.data.pagination.currentPage);
        setMediaTotalPage(response.data.pagination.totalPages);
        setTotalMedia(response.data.pagination.totalRecords);
      } else if (type === "LINK") {
        setLinkList((prev) =>
          page == 1 ? response.data.data : [...prev, ...response.data.data]
        );
        setLinkCurrentPage(response.data.pagination.currentPage);
        setLinkTotalPage(response.data.pagination.totalPages);
      } else if (type === "DOCUMENT") {
        setDocumentsList((prev) =>
          page == 1 ? response.data.data : [...prev, ...response.data.data]
        );
        setDocumentsCurrentPage(response.data.pagination.currentPage);
        setDocumentsTotalPage(response.data.pagination.totalPages);
      }
    }

    setActiveTab((t) => {
      if (type == t) setIsMediaLoading(false);
      return t;
    });
  };

  const updateGroupData = async (field, value) => {
    const endPoint = `group/update/${groupActiveChat._id}`;

    const formData = new FormData();
    formData.append(field, value);

    const response = await putFormDataApiCaller(endPoint, formData);

    if (response) {
      setGroupActiveChat((prev) => ({
        ...prev,
        ...(field ? { [field]: value } : {}),
      }));
      toast.success("Group updated successfully");
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
  };

  const handleAddGroupMember = async (selectedMembers) => {
    setIsLoading(true);
    const endPoint = `group/add-user/${groupActiveChat._id}`;
    const response = await putApiCaller(endPoint, {
      users: selectedMembers.map((member) => member._id),
    });
    if (response.status !== 200) {
      toast.error(response.response.data.message || response.message);
    } else {
      toast.success("User added successfully");
      setActiveSection("contact");
      setShowAddGroupMember(false);
    }
    setIsLoading(false);
  };

  const deleteGroup = async (info) => {
    let endPoint;
    if (info === "Exit group") {
      endPoint = `group/leave/${groupActiveChat._id}`;
    } else if (info === "Delete Group") {
      endPoint = `group/deletedByOwner/${groupActiveChat._id}`;
    }

    const response = await deleteApiCaller(endPoint);
    if (response.status !== 200) {
      toast.error(response.response.data.message || response.message);
    } else {
      setAllGroups(
        allGroups.filter((group) => group._id !== groupActiveChat._id)
      );
      setGroupActiveChat(null);
      setShowProfileView(false);
    }
  };

  const removeAdminUser = async () => {
    const endPoint = `group/${groupActiveChat._id}/remove-user/${selectedUser?._id}`;
    const response = await deleteApiCaller(endPoint);
    if (response.status !== 200) {
      toast.error(response.response.data.message || response.message);
    } else {
      setGroupActiveChat((prev) => ({
        ...prev,
        users: prev?.users?.filter((user) => user?._id !== selectedUser?._id),
      }));
      toast.success("User removed successfully");
      setRemoveUserModal(false);
      setSelectedUser(null);
    }
  };

  const handleMakeAdmin = async (user) => {
    const endPoint = `group/add-admin/${groupActiveChat._id}`;
    const response = await putApiCaller(endPoint, {
      users: [user._id],
    });
    if (response.status !== 200) {
      toast.error(response.response.data.message || response.message);
    } else {
      setGroupActiveChat((prev) => ({
        ...prev,
        adminId: [...prev.adminId, user],
      }));
    }
  };

  return (
    <section className="w-full">
      {activeSection === "contact" && !showAddGroupMember && (
        <ContactInfo
          isMediaLoading={isMediaLoading}
          mediaList={mediaList}
          totalMedia={allUserTotalRecords}
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
          toggleAddGroupMember={() =>
            setShowAddGroupMember(!showAddGroupMember)
          }
          groupActiveChat={groupActiveChat}
          setGroupActiveChat={setGroupActiveChat}
          updateGroupData={updateGroupData}
          settings={settings}
          setSettings={setSettings}
          deleteGroup={deleteGroup}
          removeAdminUser={removeAdminUser}
          handleMakeAdmin={handleMakeAdmin}
          chatConversationId={chatConversationId}
          setAllMessages={setAllMessages}
          setAllGroups={setAllGroups}
          getMediaList={getMediaList}
          setSelectedUser={setSelectedUser}
          removeUserModal={removeUserModal}
          setRemoveUserModal={setRemoveUserModal}
        />
      )}

      {/* Toggle between Contact Info and Add Group Member */}
      {showAddGroupMember && (
        <AddGroupMember
          setActiveSection={setActiveSection}
          setShowAddGroupMember={setShowAddGroupMember}
          allUser={allUser}
          allUserCurrentPage={allUserCurrentPage}
          allUserTotalPages={allUserTotalPages}
          handleAddGroupMember={handleAddGroupMember}
          isLoading={isLoading}
          fetchAllUser={fetchAllUser}
        />
      )}

      {activeSection === "media" && (
        <MediaLinks
          mediaList={mediaList}
          linkList={linkList}
          documentsList={documentsList}
          isMediaLoading={isMediaLoading}
          mediaCurrentPage={mediaCurrentPage}
          linkCurrentPage={linkCurrentPage}
          documentsCurrentPage={documentsCurrentPage}
          chatConversationId={chatConversationId}
          mediaTotalPage={mediaTotalPage}
          linkTotalPage={linkTotalPage}
          documentsTotalPage={documentsTotalPage}
          getMediaList={getMediaList}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
          secretKey={secretKey}
        />
      )}

      {activeSection === "schedule" && (
        <ScheduleMessage
          chatConversationId={chatConversationId}
          groupActiveChat={groupActiveChat}
          setActiveSection={setActiveSection}
          setShowProfileView={setShowProfileView}
        />
      )}
    </section>
  );
}
